import '.eu{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.ev{padding-left:1.5rem;}.ssr-plugin'
import '.ew{margin:1rem 0;}.ssr-plugin'
import '.ex{color:var(--gray-700);}.ssr-plugin'
import '.ey{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="eu ev ew ex ey"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
